export const environment = {
  production: false,
  configPath: 'assets/configs/rer-excel.config.json',
  keycloakUrl: 'https://auth.alpha.simadvisory.com',
  realm: 'D_SPRICED',
  clientId: 'D_SPRICED_Client',
  base_url: 'https://qa-spriced-nrp-enc.alpha.simadvisory.com',
  uploadBatchSize: 5000
};
